import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import UploadContainer from "./UploadContainer";
import actions from "../actions";
import SelectBox from "./SelectBox";
import DuplicateModal from "../../project/components/MergeOrReplaceModalSelection";
import Portal from "../../common/components/Portal";
import ConfirmationModal from "../../common/components/ConfirmationModal";
import _ from "lodash";
import SummaryModal from "./SummaryModal";
import Draggable from "react-draggable";
import Autosuggest from "react-autosuggest";
import CaptionChangeModal from "./CaptionChangeModal";
import moment from "moment";
import { resetCursor, toTitleCase, showAlert as showAlertUtil } from "../../../config/utils";
import ReactTooltip from "react-tooltip";
import ImageEditModal from "./ImageEditModal";
import TuiImageEditor from "tui-image-editor";
import assetActions from "../../assets/actions";
import waterActions from "../../water/actions";

import "tui-image-editor/dist/tui-image-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";
import { UPLOAD_TYPES } from "../constants";
import { entities } from "../../common/constants";
import { getCapitalRequestLabel, pluralizeLabel } from "../../../utils/capitalRequestLabel";
import { getPresignedUrl } from "../../common/actions";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../common/components/Loader";
import { ERROR_COPY } from "../../../config/errorMessages";

const initialState = {
    isUploading: false,
    images: [],
    filesCount: 0,
    projectList: [],
    buildingList: [],
    tradeList: [],
    user_name: localStorage.getItem("user"),

    imageData: {
        user_id: localStorage.getItem("userId"),
        project_id: "",
        building_id: "",
        trade_id: "",
        system_id: "",
        subsystem_id: "",
        captionchange: false,
        client_id: "",
        region_id: "",
        site_id: ""
    },
    errorParams: {
        project_id: false,
        building_id: false,
        trade_id: false,
        client_id: false,
        region_id: false,
        site_id: false
    },
    changecaptionmodal: false,
    tags: [],
    duplicateImages: [],
    overwriteImages: [],
    showDuplicateModal: false,
    showErrorBorder: false,
    errorMessage: "",
    initialValues: {},
    initialImages: [],
    showConfirmModal: false,
    showConfirmModalLose: false,
    uploadedFiles: {
        imagesCount: 0,
        overWriteCount: 0,
        lockedImagesCount: 0
    },
    showSummaryModal: false,
    alertMessage: "",
    startTime: "",
    endTime: "",
    chunkSize: 20,
    initialPerce: 0,
    initialTags: [],
    captionMaxLength: 100,
    selectedLabelId: "",
    labelList: [],
    labelSuggestions: [],
    image_changed: false,
    rotate: 0,
    showNextConfirmationModal: false,
    showPrevConfirmationModal: false,
    invalid_file_type: "",
    invalid_error_code: "",
    showInvalidFileModal: false,
    showImageEditModal: false,
    currentTab: "details",
    showRestoreConfirmModal: false,
    imgchang: false,
    uploadType: UPLOAD_TYPES.REGULAR,
    isImageLoading: false
};
export class UploadForm extends Component {
    constructor(props) {
        super(props);
        this.imageEditorRef = React.createRef();
        this.state = initialState;
        this.isImageEdit = false;
    }

    componentDidMount = async () => {
        if (this.props?.isAsset) await this.setState({ uploadType: UPLOAD_TYPES.NORMAL_ASSET });
        await this.refreshImageData();
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps?.selectedImages[0]?.id !== this.props?.selectedImages[0]?.id) {
            await this.refreshImageData();
            this.setImageEditor();
        }
        if (
            prevState.uploadType !== this.state.uploadType &&
            [UPLOAD_TYPES.ASSET, UPLOAD_TYPES.NORMAL_ASSET, UPLOAD_TYPES.THREE_SIXTY].includes(this.state.uploadType)
        ) {
            this.props.getDropdownList("clients");
        }
    };

    refreshImageData = async () => {
        const { entityData } = this.props;
        // for single edit
        if (this.props.selectedImages?.length === 1) {
            const { user, project, building, trade, system, sub_system, caption, labels, is_asset_image, client, region, site } =
                this.props.selectedImages[0];
            if (is_asset_image) {
                this.props.getDropdownList("clients");
                this.props.getDropdownList("regions", { client_id: client?.id });
                this.props.getDropdownList("sites", { region_id: region?.id });
            } else {
                this.getproject(project.id);
                this.props.getProjectList({ user_id: user?.id });
                this.props.getDropdownList("regions", { client_id: client?.id });
                this.props.getDropdownList("sites", { region_id: region?.id });
                this.props.getTradeList({ project_id: project.id });
                this.props.getSystemList({ project_id: project.id, trade_id: trade.id });
                if (system.id) this.props.getSubsystemList({ project_id: project.id, system_id: system.id });
                if (site?.id) {
                    this.props.getDropdownList("buildings", {
                        site_id: site?.id,
                        all: true
                    });
                } else {
                    this.props.getBuildingList({ project_id: project.id, user_id: user?.id });
                }
                this.props.getDropdownList("clients");
            }
            await this.setState({
                imageData: {
                    ...this.state.imageData,
                    user_id: user?.id,
                    caption,
                    project_id: project.id,
                    building_id: building.id,
                    trade_id: trade.id,
                    system_id: system.id,
                    subsystem_id: sub_system.id,
                    client_id: client?.id,
                    region_id: region?.id,
                    site_id: site?.id
                },
                user_name: user?.name,
                tags: labels || [],
                uploadType: is_asset_image ? UPLOAD_TYPES.ASSET : UPLOAD_TYPES.REGULAR
            });
            this.getLabelList({ project_id: project.id });
            // for multi edit
        } else if (this.props.selectedImages?.length >= 1) {
            this.props.getDropdownList("clients");
            let commonFields = this.getSharedData(this.props.selectedImages);
            const { user, project, building, trade, system, sub_system, caption, labels, is_asset_image, client, region, site } = commonFields;
            if (is_asset_image) {
                this.props.getDropdownList("clients");
                if (region) {
                    this.props.getDropdownList("regions", { client_id: client?.id });
                }
                if (site) {
                    this.props.getDropdownList("sites", { region_id: region?.id });
                }
            } else {
                if (project?.id) {
                    this.getproject(project?.id);
                    this.props.getProjectList({ user_id: user?.id });
                    this.props.getBuildingList({ project_id: project?.id, user_id: user?.id });
                    this.props.getTradeList({ project_id: project?.id });
                }
                if (trade?.id) {
                    this.props.getSystemList({ project_id: project?.id, trade_id: trade?.id });
                }
                if (system?.id) {
                    this.props.getSubsystemList({ project_id: project?.id, system_id: system?.id });
                }
                this.getLabelList({ project_id: project?.id });
            }
            let tags = [];
            if (labels && Object.keys(labels)?.length) {
                tags = Object.keys(labels).map(elem => ({ name: labels[elem]?.name }));
            }
            await this.setState({
                imageData: {
                    ...this.state.imageData,
                    user_id: user?.id || "",
                    caption: caption || "",
                    project_id: project?.id || "",
                    building_id: building?.id || "",
                    trade_id: trade?.id || "",
                    system_id: system?.id || "",
                    subsystem_id: sub_system?.id || "",
                    client_id: client?.id || "",
                    region_id: region?.id || "",
                    site_id: site?.id || ""
                },
                user_name: user?.name || "",
                tags: tags,
                uploadType: is_asset_image ? UPLOAD_TYPES.ASSET : UPLOAD_TYPES.REGULAR
            });
            // for add
        } else {
            await this.setState({
                imageData: { ...this.state.imageData, user_id: localStorage.getItem("userId") },
                user_name: localStorage.getItem("user")
            });
            if ([UPLOAD_TYPES.ASSET, UPLOAD_TYPES.NORMAL_ASSET, UPLOAD_TYPES.THREE_SIXTY].includes(this.state.uploadType)) {
                this.props.getDropdownList("clients");
                if (this.props.entity === entities.ASSET_MANAGEMENT) {
                    this.props.getDropdownList("regions", { client_id: entityData?.client?.id });
                    this.props.getDropdownList("sites", { region_id: entityData?.region?.id });
                    await this.setState({
                        imageData: {
                            ...this.state.imageData,
                            client_id: entityData?.client?.id,
                            region_id: entityData?.region?.id,
                            site_id: entityData?.site?.id
                        }
                    });
                }
            } else {
                let userId = localStorage.getItem("role") !== "super_admin" ? localStorage.getItem("userId") : null;
                await this.props.getDropdownList("clients");

                await this.props.getProjectList({ user_id: userId });
                if (this.props.entity === entities.BUILDINGS) {
                    this.props.getDropdownList("sites", { region_id: entityData?.region?.id });
                    this.props.getDropdownList("regions", { client_id: entityData?.client?.id });
                    this.props.getBuildingList({ project_id: entityData?.projects?.[0]?.id });
                    await this.setState({
                        imageData: {
                            ...this.state.imageData,
                            client_id: entityData?.client?.id,
                            project_id: entityData?.projects?.[0]?.id,
                            region_id: entityData?.region?.id,
                            site_id: entityData?.site?.id,
                            building_id: entityData?.id
                        }
                    });
                } else if (this.props.entity === entities.REGIONS) {
                    this.props.getDropdownList("sites", { region_id: entityData?.id });
                    this.props.getDropdownList("regions", { client_id: entityData?.client?.id });
                    this.props.getBuildingList({ project_id: entityData?.projects?.[0]?.id });
                    this.props.getTradeList({ project_id: entityData?.projects?.[0]?.id });
                    if (entityData?.trade?.id)
                        this.props.getSystemList({ project_id: entityData?.projects?.[0]?.id, trade_id: entityData?.trade?.id });
                    if (entityData?.system?.id)
                        this.props.getSubsystemList({ project_id: entityData?.projects?.[0]?.id, system_id: entityData?.system?.id });
                    await this.setState({
                        imageData: {
                            ...this.state.imageData,
                            client_id: entityData?.client?.id,
                            project_id: entityData?.projects?.[0]?.id,
                            region_id: entityData?.id,
                            site_id: entityData?.site?.id,
                            building_id: entityData?.building?.id
                        }
                    });
                } else if (this.props.entity === entities.SITES) {
                    this.props.getDropdownList("sites", { region_id: entityData?.region?.id });
                    this.props.getDropdownList("regions", { client_id: entityData?.client?.id });
                    this.props.getBuildingList({ project_id: entityData?.projects?.[0]?.id });
                    await this.setState({
                        imageData: {
                            ...this.state.imageData,
                            client_id: entityData?.client?.id,
                            project_id: entityData?.projects?.[0]?.id,
                            region_id: entityData?.region?.id,
                            site_id: entityData?.id,
                            building_id: entityData?.building?.id
                        }
                    });
                } else {
                    const defaultproject = localStorage.getItem("default_project");
                    if (entityData?.id) {
                        const { trade, building, system, sub_system, project } = entityData;
                        await this.handleProjectSelect(project?.id);
                        await this.handleBuildingSelect(building.id);
                        await this.handleTradeSelect(trade.id);
                        await this.handleSystemSelect(system.id);
                        await this.handleSubsytemSelect(sub_system.id);
                        // await this.handleProjectAndClient(defaultproject);
                    } else if (defaultproject) {
                        await this.handleProjectAndClient(defaultproject);
                        await this.handleProjectSelect(defaultproject);
                    }
                }
            }
        }
        this.setState({ initialValues: this.state.imageData, initialImages: this.state.images, initialTags: _.cloneDeep(this.state.tags) });
    };

    getLabelList = async params => {
        let labelList = [];
        await this.props.getLabelList(params);
        const { getLabelList } = this.props.imageReducer;
        if (getLabelList.success) {
            labelList = getLabelList?.labels || [];
        }
        this.setState({
            labelList
        });
    };

    getSharedData = arr => {
        const firstObj = arr[0];
        const result = {};
        for (const key in firstObj) {
            const values = arr?.map(obj => obj && obj[key]);
            if (typeof firstObj[key] === "object" && firstObj[key] !== null) {
                const nestedResult = this.getSharedData(values);
                result[key] = nestedResult;
            } else if (new Set(values).size === 1) {
                result[key] = firstObj[key];
            } else {
                result[key] = null;
            }
        }
        return result;
    };

    handleFileInput = async (files, invalid_files) => {
        const tooManyFiles = invalid_files?.some(file => file.errors?.[0]?.code === "too-many-files");
        const errorMsg = invalid_files[0]?.errors?.[0]?.message;
        this.setState({
            filesCount: files?.length || 0,
            images: files,
            invalid_file_type: invalid_files,
            invalid_error_code: tooManyFiles ? "too-many-files" : errorMsg,
            showInvalidFileModal: invalid_files.length ? true : false
        });
    };

    getproject = async id => {
        await this.props.getSelectedProject(id);
        const { selectedProject } = this.props.imageReducer;
        await this.setState({
            captionMaxLength: selectedProject.img_length
        });
        return selectedProject;
    };

    handleProjectAndClient = async projectId => {
        const selectedProject = await this.getproject(projectId);

        if (selectedProject?.client?.id) {
            await this.handleClientSelect(selectedProject.client.id, { reset: true });
        }
    };

    handleClientSelect = async (id, defaultProject = false) => {
        const { uploadType } = this.state;
        let userId = localStorage.getItem("role") !== "super_admin" ? localStorage.getItem("userId") : null;
        this.setState({
            imageData: {
                ...this.state.imageData,
                client_id: id,
                region_id: "",
                site_id: "",
                project_id: defaultProject ? this.state.imageData.project_id : "",
                building_id: "",
                trade_id: "",
                system_id: "",
                subsystem_id: ""
            }
        });

        if (defaultProject) {
            await this.props.getUserDefaultTrade(this.state.imageData.project_id);
            const { getUserDefaultTradeResponse } = this.props.imageReducer;
            if (getUserDefaultTradeResponse?.id) {
                this.handleTradeSelect(getUserDefaultTradeResponse?.id);
            }
        }
        this.props.getProjectList({ user_id: userId, client_id: id });

        if (uploadType === UPLOAD_TYPES.ASSET || uploadType === UPLOAD_TYPES.NORMAL_ASSET || uploadType === UPLOAD_TYPES.REGULAR) {
            this.props.getDropdownList("regions", {
                client_id: id
            });
        }
    };
    handleRegionSelect = async id => {
        this.setState({
            imageData: {
                ...this.state.imageData,
                region_id: id,
                site_id: "",
                building_id: ""
            }
        });
        if (id) {
            this.props.getDropdownList("sites", {
                region_id: id
            });
        }
    };
    handleSiteSelect = async id => {
        let userId = localStorage.getItem("role") !== "super_admin" ? localStorage.getItem("userId") : null;
        const { imageData } = this.state;
        this.setState({
            imageData: {
                ...this.state.imageData,
                site_id: id,
                building_id: ""
            }
        });
        if (id) {
            this.props.getDropdownList("buildings", {
                site_id: id,
                all: true
            });
        } else this.props.getBuildingList({ project_id: imageData?.project_id, user_id: userId });
    };

    handleProjectSelect = async id => {
        const { uploadType } = this.state;
        await this.setState({
            imageData: {
                ...this.state.imageData,
                project_id: id,
                building_id: "",
                trade_id: "",
                system_id: "",
                subsystem_id: "",
                region_id: "",
                site_id: ""
            }
        });
        this.getproject(id);
        if (uploadType === UPLOAD_TYPES.REGULAR) {
            this.props.getBuildingList({ project_id: id, user_id: this.state.imageData?.user_id });
            this.props.getTradeList({ project_id: id });
            await this.props.getUserDefaultTrade(id);
            const { getUserDefaultTradeResponse } = this.props.imageReducer;
            if (getUserDefaultTradeResponse?.id) {
                this.handleTradeSelect(getUserDefaultTradeResponse?.id);
            }
        } else if (uploadType === UPLOAD_TYPES.THREE_SIXTY) {
            this.props.getDropdownList("regions", {
                client_id: this.state.imageData.client_id
            });
        }

        this.getLabelList({ project_id: id });
    };
    handleBuildingSelect = async id => {
        await this.setState({
            imageData: {
                ...this.state.imageData,
                building_id: id
            }
        });

        if (!this.state.imageData?.region_id || !this.state.imageData?.site_id) {
            await this.props.getBuildingById(id);

            const {
                waterReducer: { getBuildingByIdResponse }
            } = this.props;

            if (getBuildingByIdResponse) {
                const { region, site } = getBuildingByIdResponse;

                if (region?.id && site?.id) {
                    await this.setState({
                        imageData: {
                            ...this.state.imageData,
                            region_id: region.id,
                            site_id: site.id
                        }
                    });
                    await this.props.getDropdownList("regions", {
                        client_id: this.state.imageData.client_id
                    });
                    await this.props.getDropdownList("sites", { region_id: region.id });
                    await this.props.getDropdownList("buildings", { site_id: site.id, all: true });
                }
            }
        }
    };

    handleTradeSelect = async id => {
        await this.setState({ imageData: { ...this.state.imageData, trade_id: id, system_id: "", subsystem_id: "" } });
        this.props.getSystemList({ project_id: this.state.imageData.project_id, trade_id: id });
    };
    handleSystemSelect = async id => {
        const { imageData } = this.state;
        await this.setState({ imageData: { ...imageData, system_id: id, subsystem_id: "" } });
        this.props.getSubsystemList({ project_id: imageData.project_id, trade_id: imageData.trade_id, system_id: id });
    };
    handleSubsytemSelect = async id => {
        await this.setState({ imageData: { ...this.state.imageData, subsystem_id: id } });
    };

    validate = () => {
        const { imageData, images, uploadType } = this.state;
        const { selectedImages } = this.props;
        let errorParams = {};
        let errorMessage = "";
        let showErrorBorder = false;
        if (uploadType === UPLOAD_TYPES.REGULAR) {
            if (!selectedImages?.length && !images?.length) {
                errorMessage = "Please choose images";
                showErrorBorder = true;
            } else if (!imageData.user_id?.trim().length) {
                errorMessage = "No User Found";
                showErrorBorder = true;
                errorParams.user_id = true;
            } else if (!imageData.project_id?.trim().length) {
                errorMessage = "Please select project";
                showErrorBorder = true;
                errorParams.project_id = true;
            } else if (!imageData.building_id?.trim().length) {
                errorMessage = "Please select building";
                showErrorBorder = true;
                errorParams.building_id = true;
            } else if (!imageData.trade_id?.trim().length) {
                errorMessage = "Please select trade";
                showErrorBorder = true;
                errorParams.trade_id = true;
            }
        } else if (uploadType === UPLOAD_TYPES.THREE_SIXTY) {
            if (!selectedImages?.length && !images?.length) {
                errorMessage = "Please choose images";
                showErrorBorder = true;
            } else if (!imageData.user_id?.trim().length) {
                errorMessage = "No User Found";
                showErrorBorder = true;
                errorParams.user_id = true;
            } else if (!imageData.client_id?.trim().length) {
                errorMessage = "Please select client";
                showErrorBorder = true;
                errorParams.client_id = true;
            } else if (!imageData.project_id?.trim().length) {
                errorMessage = "Please select project";
                showErrorBorder = true;
                errorParams.project_id = true;
            } else if (!imageData.site_id?.trim().length) {
                errorMessage = "Please select site";
                showErrorBorder = true;
                errorParams.site_id = true;
            }
        } else {
            if (!selectedImages?.length && !images?.length) {
                errorMessage = "Please choose images";
                showErrorBorder = true;
            } else if (!imageData.user_id?.trim().length) {
                errorMessage = "No User Found";
                showErrorBorder = true;
                errorParams.user_id = true;
            } else if (!imageData.client_id?.trim().length) {
                errorMessage = "Please select client";
                showErrorBorder = true;
                errorParams.client_id = true;
            } else if (!imageData.region_id?.trim().length) {
                errorMessage = "Please select region";
                showErrorBorder = true;
                errorParams.region_id = true;
            } else if (!imageData.site_id?.trim().length) {
                errorMessage = "Please select site";
                showErrorBorder = true;
                errorParams.site_id = true;
            }
        }

        this.setState({
            showErrorBorder,
            errorParams,
            errorMessage
        });
        if (showErrorBorder) return false;
        return true;
    };

    handleImageUpload = async () => {
        if (this.validate()) {
            if (this.state.uploadType === UPLOAD_TYPES.THREE_SIXTY) {
                this.upload360Images();
            } else {
                let containDuplicates = await this.checkDuplicateImages();
                if (!containDuplicates) {
                    this.sendFilesAsChunks();
                } else {
                    this.toggleDuplicateModal();
                }
            }
        }
    };

    convertImageExtensionToJpg = filename => {
        const lowercasedFilename = filename.toLowerCase();
        if (lowercasedFilename.endsWith(".heic")) {
            return filename.replace(/\.heic$/i, ".jpeg");
        }
        //  else if (lowercasedFilename.endsWith(".jpeg")) {
        //     return filename.replace(/\.jpeg$/i, ".jpg");
        // }
        return filename;
    };

    checkDuplicateImages = async () => {
        const {
            imageData: { user_id, project_id, building_id, trade_id, system_id, subsystem_id, client_id, region_id, site_id },
            images,
            uploadType
        } = this.state;
        let imageCheckParams = {
            image_list: [],
            user_id,
            project_id,
            building_id,
            trade_id,
            system_id,
            subsystem_id,
            client_id,
            region_id,
            site_id
        };

        images.map(item => imageCheckParams.image_list.push(this.convertImageExtensionToJpg(item.name)));
        await this.props.checkDuplicateImages(imageCheckParams, uploadType);
        const { success, duplicate_list } = this.props.imageReducer.duplicateImages;
        if (success) {
            if (duplicate_list?.length) {
                this.setState({ duplicateImages: duplicate_list });
                return true;
            } else {
                return false;
            }
        } else {
            console.log(ERROR_COPY.GENERIC);
        }
    };

    sendFilesAsChunks = async () => {
        await this.props.setProgressZero(0);
        this.setState({ isUploading: true, startTime: new Date() });
        const { images, overwriteImages, chunkSize } = this.state;
        let fileQueue = [...images];
        let stop = false;
        while (fileQueue.length && !stop) {
            if (fileQueue.length > chunkSize) {
                let tempQueue = fileQueue;
                let chunks = tempQueue.splice(0, chunkSize);
                let chunkOwriteImg = [];
                if (overwriteImages.length) {
                    chunkOwriteImg = overwriteImages.filter(item => chunks.some(chunk => this.convertImageExtensionToJpg(chunk.name) === item));
                }
                fileQueue = tempQueue;
                const res = await this.uploadToServer(chunks, chunkOwriteImg);
                if (!res) stop = true;
            } else {
                let chunks = fileQueue;
                let chunkOwriteImg = [];
                if (overwriteImages.length) {
                    chunkOwriteImg = overwriteImages.filter(item => chunks.some(chunk => this.convertImageExtensionToJpg(chunk.name) === item));
                }
                fileQueue = [];
                const res = await this.uploadToServer(chunks, chunkOwriteImg);
                if (!res) stop = true;
            }
        }
        this.setState(
            {
                isUploading: false,
                showSummaryModal: true,
                initialPerce: 0,
                endTime: new Date(),
                alertMessage: stop
                    ? this.props.imageReducer?.imageUploadResponse?.detail ??
                      this.props.imageReducer?.imageUploadResponse?.error ??
                      "Upload Failed. Please refresh and try again."
                    : "Upload Completed Successfully"
            },
            () => {
                this.props.refreshImageList();
                // this.props.onCancel();
                this.showAlert();
            }
        );
    };

    uploadToServer = async (data, overwriteImages) => {
        const {
            imageData,
            uploadedFiles: { imagesCount, overWriteCount, lockedImagesCount },
            chunkSize,
            images,
            initialPerce,
            uploadType
        } = this.state;
        let totalApiCall = Math.ceil(images?.length / chunkSize);
        let formData = new FormData();
        let folder_tags = [];
        let tags = this.state.tags.map(tag => tag.name).filter(tag => tag);
        Object.entries(imageData)
            .filter(([key, value]) => value)
            .map(([key, value]) => formData.append(`${key}`, value));

        data.forEach((item, index) => {
            folder_tags.push(this.convertImageExtensionToJpg(item.path));
            formData.append(`image${index + 1}`, item);
        });
        if (uploadType === UPLOAD_TYPES.ASSET || uploadType === UPLOAD_TYPES.NORMAL_ASSET) {
            overwriteImages = { data: overwriteImages };
        }
        formData.append("owrite_images", JSON.stringify(overwriteImages));
        if (uploadType === UPLOAD_TYPES.ASSET || uploadType === UPLOAD_TYPES.NORMAL_ASSET) {
            tags = { data: tags };
            folder_tags = { data: folder_tags };
            formData.append("tags", JSON.stringify(tags));
            formData.append("folder_tags", JSON.stringify(folder_tags));
        } else {
            formData.append("tags", JSON.stringify(tags));
            formData.append("folder_tags", JSON.stringify(folder_tags));
        }

        await this.props.uploadImage(formData, totalApiCall, initialPerce, uploadType);
        const { success, error, success_images, overwritten_images, locked_images, detail = null } = this.props.imageReducer.imageUploadResponse;
        if (success) {
            this.setState({
                uploadedFiles: {
                    imagesCount: imagesCount + success_images?.length + overwritten_images?.length,
                    overWriteCount: overWriteCount + overwritten_images?.length,
                    lockedImagesCount: lockedImagesCount + locked_images?.length
                },
                initialPerce: initialPerce + 100
            });
            return true;
        } else {
            if (error || detail)
                this.setState({ alertMessage: typeof detail === "string" ? detail : error }, () => {
                    this.showAlert();
                });
            console.log("upload failed", error);
            return false;
        }
    };

    upload360Images = async () => {
        await this.props.setProgressZero(0);
        this.setState({ isUploading: true, startTime: new Date() });
        const {
            imageData: { user_id, client_id, project_id, region_id, site_id },
            images,
            initialPerce,
            uploadType
        } = this.state;
        let totalApiCall = 1;
        let formData = new FormData();

        formData.append(`user_id`, user_id);
        formData.append(`client_id`, client_id);
        formData.append(`project_id`, project_id);
        formData.append(`site_id`, site_id);
        formData.append(`region_id`, region_id);
        formData.append(`file`, images[0]);

        await this.props.uploadImage(formData, totalApiCall, initialPerce, uploadType);
        const { success, error } = this.props.imageReducer.imageUploadResponse;
        this.setState(
            {
                isUploading: false,
                showSummaryModal: true,
                initialPerce: 0,
                endTime: new Date(),
                alertMessage: success ? "Upload Completed Successfully" : error ?? "Upload Failed. Please refresh and try again."
            },
            () => {
                if (success) this.props.refreshImageList();
                this.showAlert();
            }
        );
    };

    toggleDuplicateModal = () => {
        this.setState({
            showDuplicateModal: !this.state.showDuplicateModal
        });
    };

    renderDuplicateModal = () => {
        const { showDuplicateModal, duplicateImages } = this.state;

        if (!showDuplicateModal) return null;
        return (
            <Portal
                body={
                    <DuplicateModal
                        onCancel={this.toggleDuplicateModal}
                        message={"Duplicate Images Found !"}
                        subMessage={`${
                            duplicateImages?.length > 1 ? `${duplicateImages?.length} Images` : `${duplicateImages?.length} Image`
                        } already exist.`}
                        subMessage1={`Do you want to merge or replace ?`}
                        buttonNo={{ label: "Replace", value: "replace", note: " (Upload all and Overwrite Duplicates)" }}
                        buttonYes={{ label: "Merge", value: "merge", note: " (Upload all and Skip Duplicates)" }}
                        hasCancelButton={true}
                        onSelection={this.onDuplicateSelection}
                    />
                }
                onCancel={this.toggleDuplicateModal}
            />
        );
    };
    // toggleInvalidFileModal = () => {
    //     this.setState({
    //         showInvalidFileModal: !this.state.showInvalidFileModal
    //     });
    // };

    getRecommendationEntityLabels = () => {
        const { entity, entityData, projectReducer } = this.props;
        const isCR = entity === entities.RECOMMENDATIONS && entityData?.infrastructure_request === "yes";
        const crLabel = getCapitalRequestLabel(projectReducer?.getProjectByIdResponse?.miscellaneous);
        const entityLabel = entity === entities.ASSET_MANAGEMENT ? "Asset" : isCR ? crLabel : "Recommendation";
        const entityPluralLabel = entity === entities.ASSET_MANAGEMENT ? "Asset" : isCR ? pluralizeLabel(crLabel) : "Recommendations";
        return { isCR, entityLabel, entityPluralLabel };
    };

    renderInvalidTypeModal = () => {
        const { showInvalidFileModal, invalid_file_type, invalid_error_code, uploadType } = this.state;
        const { entityLabel } = this.getRecommendationEntityLabels();

        if (!showInvalidFileModal) return null;
        const invalid_file_count = invalid_file_type && invalid_file_type.length;
        const fileText = invalid_file_count === 1 ? "File" : "Files";
        const tooManyFilesCount =
            invalid_file_type?.filter(file => file.errors?.some(err => err.code === "too-many-files")).length || 0;
        const nonZipCount =
            invalid_file_type?.filter(file => file.errors?.some(err => err.message === "non_zip_file")).length || 0;
        const invalidNameCount =
            invalid_file_type?.filter(file => file.errors?.some(err => err.message === "invalid_file_name")).length || 0;
        const nameTooLongCount =
            invalid_file_type?.filter(file => file.errors?.some(err => err.message === "file_name_too_long")).length || 0;
        const unsupportedTypeCount =
            invalid_file_type?.filter(file =>
                file.errors?.some(err => err.message === "non_image_file" || err.message === "Non-image file")
            ).length || 0;

        const messages = [];

        if (tooManyFilesCount) {
            messages.push(
                uploadType === UPLOAD_TYPES.THREE_SIXTY
                    ? "You can only upload 1 Zip file at a time."
                    : `You can only upload up to 10 images at a time within a ${entityLabel.toLowerCase()}. If you wish to upload more than 10 images, please use the image management menu.`
            );
        }
        if (nonZipCount) {
            messages.push("Only Zip files are allowed to be uploaded.");
        }
        if (invalidNameCount) {
            messages.push(
                `We found and removed ${invalidNameCount} image(s) with an invalid filename format.`
            );
        }
        if (nameTooLongCount) {
            messages.push(
                `We found and removed ${nameTooLongCount} image(s) with a filename longer than 150 characters. Please rename and try again.`
            );
        }
        if (unsupportedTypeCount) {
            const unsupportedFileText = unsupportedTypeCount === 1 ? "File" : "Files";
            messages.push(
                `We detected and removed ${unsupportedTypeCount} Unsupported ${unsupportedFileText} (Accepted image formats: JPG, JPEG, PNG, HEIC).`
            );
        }

        const message =
            messages.length > 0
                ? messages.join(" ")
                : `We Detected and Removed ${invalid_file_count} Unsupported ${fileText} (Accepted image formats: JPG, JPEG, PNG, HEIC)`;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        // heading={"Do you want to clear and lose all changes?"}
                        message={message}
                        singleOk={true}
                        onlyOk={() => this.setState({ showInvalidFileModal: false })}
                        cancel={() => this.setState({ showInvalidFileModal: false })}
                    />
                }
                // onCancel={() => this.setState({ showInvalidFileModal: false })}
            />
        );
    };

    onDuplicateSelection = async type => {
        const { duplicateImages } = this.state;
        this.toggleDuplicateModal();
        switch (type) {
            case "replace":
                await this.setState({ overwriteImages: duplicateImages });
                this.sendFilesAsChunks();
                break;
            case "merge":
                await this.setState(state => {
                    const images = state.images?.filter(img => duplicateImages.some(dupImg => this.convertImageExtensionToJpg(img.name) !== dupImg));
                    const filesCount = images.length;
                    return { images, filesCount };
                });
                this.sendFilesAsChunks();
                break;

            default:
                break;
        }
    };

    cancelForm = () => {
        const { initialValues, imageData, images, initialImages, initialTags, tags, image_changed } = this.state;

        if (
            (_.isEqual(initialImages, images) && _.isEqual(initialTags, tags) && !image_changed && this.state.imgchang?.ui?.submenu === false) ||
            (this.state.imgchang?.ui?.submenu === undefined && _.isEqual(initialValues, imageData))
        ) {
            this.props.onCancel();
        } else {
            this.setState({
                showConfirmModal: true
            });
        }
    };
    handleTabChangeConfirm = () => {
        if (this.state.imgchang?.ui?.submenu !== false && this.state.currentTab === "edit image") {
            this.setState({
                showConfirmModalLose: true
            });
        } else {
            this.handleTabChange("details");
        }
    };

    renderConfirmationModal = () => {
        const { showConfirmModal } = this.state;
        if (!showConfirmModal) return null;

        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to cancel and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => this.setState({ showConfirmModal: false })}
                        onYes={() => this.props.onCancel()}
                        cancel={() => this.setState({ showConfirmModal: false })}
                    />
                }
                onCancel={() => this.setState({ showConfirmModal: false })}
            />
        );
    };

    showAlert = () => showAlertUtil(this.state.alertMessage, true);

    validateEdit = editedDatas => {
        let errorParams = {};
        let errorMessage = "";
        let showErrorBorder = false;
        if (editedDatas.hasOwnProperty("project_id") && !editedDatas?.project_id?.trim().length) {
            errorMessage = "Please select project";
            showErrorBorder = true;
            errorParams.project_id = true;
        } else if (editedDatas.hasOwnProperty("building_id") && !editedDatas?.building_id?.trim().length) {
            errorMessage = "Please select building";
            showErrorBorder = true;
            errorParams.building_id = true;
        } else if (editedDatas.hasOwnProperty("trade_id") && !editedDatas?.trade_id?.trim().length) {
            errorMessage = "Please select trade";
            showErrorBorder = true;
            errorParams.trade_id = true;
        } else if (editedDatas.hasOwnProperty("client_id") && !editedDatas?.client_id?.trim().length) {
            errorMessage = "Please select client";
            showErrorBorder = true;
            errorParams.client_id = true;
        } else if (editedDatas.hasOwnProperty("region_id") && !editedDatas?.region_id?.trim().length) {
            errorMessage = "Please select region";
            showErrorBorder = true;
            errorParams.region_id = true;
        } else if (editedDatas.hasOwnProperty("site_id") && !editedDatas?.site_id?.trim().length) {
            errorMessage = "Please select site";
            showErrorBorder = true;
            errorParams.site_id = true;
        }
        this.setState({
            showErrorBorder,
            errorParams,
            errorMessage
        });
        if (showErrorBorder) return false;
        return true;
    };

    handleUpdate = async () => {
        let { imageData, initialValues } = this.state;
        const { selectedImages } = this.props;
        let image_ids = [];
        let editedData = {};
        selectedImages.map(img => image_ids.push(img.id));

        // taking edited data only
        Object.entries(imageData).forEach(([key, value]) => {
            if (!_.isEqual(value, initialValues[key])) {
                editedData[key] = value;
            }
        });

        // validating edited fields
        if (this.validateEdit(editedData)) {
            if (editedData.hasOwnProperty("caption") && selectedImages.some(item => item.recommendations?.length)) {
                this.setState({
                    changecaptionmodal: true
                });
            } else {
                this.updateImageData();
            }
        }
    };

    updateImageData = async params => {
        let { imageData, tags, initialTags, initialValues, image_changed } = this.state;
        const { selectedImages } = this.props;
        let image_ids = [];
        let editedData = {};
        selectedImages.map(img => image_ids.push(img.id));
        Object.entries(imageData).forEach(([key, value]) => {
            if (!_.isEqual(value, initialValues[key])) {
                editedData[key] = value;
            }
        });
        this.setState({ isUploading: true });
        // taking removed tags
        tags = tags.map(tag => tag.name).filter(tag => tag);
        let removed_tags = initialTags.filter(object1 => !tags.some(object2 => object1.name === object2)) || [];
        if (removed_tags?.length) {
            removed_tags = removed_tags.map(tag => tag.name);
        }
        // // if image rotated
        if (image_changed && this.state.rotate) {
            await this.props.rotateImages({ degree: this.state.rotate, image_upload_id: selectedImages[0].id });
            const { s3_image_key, s3_thumbnail_key } = this.props.imageReducer.rotateImageResponse;
            selectedImages[0].s3_thumbnail_key = s3_thumbnail_key;
            selectedImages[0].s3_image_key = s3_image_key;
            // this.setState({ image_changed: false, rotate: 0 });
        }

        await this.props.updateImage({ ...editedData, tags, removed_tags, image_ids, rotate: image_changed, ...(params ? params : {}) });
        this.setState({ image_changed: false, rotate: 0 });
        const { success, error, message } = this.props.imageReducer.imageUpdateResponse;
        if (success) {
            this.setState(
                {
                    isUploading: false,
                    alertMessage: message
                },
                () => {
                    // this.props.refreshImageList();
                    this.updateCurrentImages({ editedData, removed_tags, tags });
                    if (!this.isImageEdit) {
                        this.props.onCancel();
                        this.showAlert();
                    }
                }
            );
        } else {
            this.setState(
                {
                    isUploading: false,
                    alertMessage: error || message || "Failed to update image!"
                },
                () => {
                    this.showAlert();
                }
            );
        }
        this.isImageEdit = false;
    };

    renderCaptionChangeConfirmationModal = () => {
        const { changecaptionmodal } = this.state;
        const { entityPluralLabel } = this.getRecommendationEntityLabels();
        if (!changecaptionmodal) return null;
        return (
            <Portal
                body={
                    <CaptionChangeModal
                        onCancel={() => this.setState({ changecaptionmodal: false })}
                        message={`Do you want the updated Caption pushed to ALL image Captions in ${entityPluralLabel.toLowerCase()} with this image?`}
                        buttonNo={{ label: "No", value: "no", note: "Caption updated ONLY in Image Management Gallery" }}
                        buttonYes={{
                            label: "Yes",
                            value: "yes",
                            note: `Caption updated in Image Management Gallery AND in ALL ${entityPluralLabel} containing this image`
                        }}
                        hasCancelButton={true}
                        onSelection={this.onImageCaptionSelect}
                    />
                }
            />
        );
    };
    onImageCaptionSelect = async type => {
        switch (type) {
            case "no":
                await this.setState({ imageData: { ...this.state.imageData, captionchange: false }, changecaptionmodal: false });
                this.updateImageData();
                break;
            case "yes":
                await this.setState({ imageData: { ...this.state.imageData, captionchange: true }, changecaptionmodal: false });
                this.updateImageData();
                break;

            default:
                break;
        }
    };

    updateCurrentImages = data => {
        this.props.updateImageListAfterUpdate(data, this.props.selectedImages);
    };

    renderConfirmationLabelModal = () => {
        const { showLabelModal, tags, selectedLabelId } = this.state;
        if (!showLabelModal) return null;
        if (showLabelModal)
            return (
                <Portal
                    body={
                        <ConfirmationModal
                            heading={"Do you want to delete this label?"}
                            message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                            type="cancel"
                            onNo={() => this.setState({ showLabelModal: false, selectedLabelId: "" })}
                            onYes={() =>
                                this.setState({
                                    tags: tags.filter((tag, idx) => idx !== selectedLabelId),
                                    showLabelModal: false,
                                    selectedLabelId: ""
                                })
                            }
                        />
                    }
                    onCancel={() => this.setState({ showLabelModal: false, selectedLabelId: "" })}
                />
            );
    };

    labelDelete = index => {
        this.setState({ showLabelModal: true, selectedLabelId: index });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            labelSuggestions: this.getSuggestions(value)
        });
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            labelSuggestions: []
        });
    };

    getSuggestions = value => {
        let { labelList, tags } = this.state;
        labelList = labelList.filter(item => !tags.some(tag => tag.name === item.name));
        const inputValue = value?.trim().toLowerCase();
        const inputLength = inputValue.length;

        return inputLength === 0 ? [] : labelList.filter(item => item.name?.toString()?.toLowerCase().includes(inputValue));
    };

    getSuggestionValue = suggestion => suggestion?.name || "";

    renderSuggestion = suggestion => <span>{suggestion?.name}</span>;

    setRotate = () => {
        this.setState({ image_changed: true });
        if (this.state.rotate === 270) {
            this.setState({ rotate: 0 });
        } else {
            this.setState({ rotate: this.state.rotate + 90 });
        }
    };

    confirmViewNext = () => {
        const { selectedImages, handleNext } = this.props;
        const { initialValues, imageData, images, initialImages, initialTags, tags, image_changed } = this.state;
        if (_.isEqual(initialValues, imageData) && _.isEqual(initialImages, images) && _.isEqual(initialTags, tags) && !image_changed) {
            handleNext(selectedImages[0].id);
        } else {
            this.setState({
                showNextConfirmationModal: true
            });
        }
    };
    confirmViewPrev = () => {
        const { selectedImages, handlePrev } = this.props;
        const { initialValues, imageData, images, initialImages, initialTags, tags, image_changed } = this.state;
        if (_.isEqual(initialValues, imageData) && _.isEqual(initialImages, images) && _.isEqual(initialTags, tags) && !image_changed) {
            handlePrev(selectedImages[0].id);
        } else {
            this.setState({
                showPrevConfirmationModal: true
            });
        }
    };
    renderNextConfirmationModal = () => {
        const { selectedImages, handleNext } = this.props;
        const { showNextConfirmationModal } = this.state;
        if (!showNextConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to clear and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => this.setState({ showNextConfirmationModal: false })}
                        onYes={() => {
                            this.setState(initialState);
                            handleNext(selectedImages[0].id);
                        }}
                        cancel={() => this.setState({ showNextConfirmationModal: false })}
                    />
                }
                onCancel={() => this.setState({ showNextConfirmationModal: false })}
            />
        );
    };
    renderPrevConfirmationModal = () => {
        const { selectedImages, handlePrev } = this.props;
        const { showPrevConfirmationModal } = this.state;
        if (!showPrevConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to clear and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => this.setState({ showPrevConfirmationModal: false })}
                        onYes={() => {
                            this.setState(initialState);
                            handlePrev(selectedImages[0].id);
                        }}
                        cancel={() => this.setState({ showPrevConfirmationModal: false })}
                    />
                }
                onCancel={() => this.setState({ showPrevConfirmationModal: false })}
            />
        );
    };

    renderImageEditModal = () => {
        const { showImageEditModal } = this.state;
        if (showImageEditModal) {
            return <ImageEditModal />;
        }
        return null;
    };

    handleTabChange = async key => {
        this.setState({ showConfirmModalLose: false, currentTab: key }, () => {
            if (key === "edit image") {
                this.setImageEditor();
            }
        });
    };
    renderConfirmationModalLose = () => {
        const { showConfirmModalLose } = this.state;
        if (!showConfirmModalLose) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        type="cancel"
                        heading={"Do you want to change the tab and lose all changes?"}
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => this.setState({ showConfirmModalLose: false })}
                        onYes={() => {
                            this.handleTabChange("details");
                            if (this.state.imgchang.destroy) this.state.imgchang.destroy();
                        }}
                        cancel={() => this.setState({ showConfirmModalLose: false })}
                    />
                }
                onCancel={() => this.setState({ showConfirmModalLose: false })}
            />
        );
    };

    setImageEditor = async () => {
        try {
            let _this = this;
            if (!this.imageEditorRef.current) {
                return;
            }
            this.setState({ isImageLoading: true });
            const myTheme = {
                "header.display": "none"
            };
            const { selectedImages = [] } = this.props;
            let imageUrl = selectedImages[0]?.is_edited ? `${selectedImages[0]?.s3_eimage_key}` : `${selectedImages[0]?.s3_image_key}`;
            let presignedUrl = await getPresignedUrl(imageUrl);

            const tuiEditor = new TuiImageEditor(this.imageEditorRef.current, {
                includeUI: {
                    loadImage: {
                        path: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
                        name: "BlankImage"
                    },
                    uiSize: {
                        height: "495px"
                    },
                    shape: {
                        strokeWidth: 20
                    },
                    menu: ["crop", "flip", "rotate", "draw", "shape", "icon", "mask", "text", "filter"],
                    menuBarPosition: "left",
                    theme: myTheme
                },
                selectionStyle: {
                    cornerSize: 50,
                    rotatingPointOffset: 1000,
                    cornerStyle: "circle",
                    cornerStrokeColor: "#FFFFFF",
                    cornerColor: "#FFFFFF",
                    borderColor: "#FFFFFF",
                    transparentCorners: false
                }
            });

            tuiEditor.loadImageFromURL = (function () {
                var cached_function = tuiEditor.loadImageFromURL;
                function waitUntilImageEditorIsUnlocked(tuiEditor) {
                    return new Promise((resolve, reject) => {
                        const interval = setInterval(() => {
                            if (!tuiEditor._invoker._isLocked) {
                                clearInterval(interval);
                                resolve();
                            }
                        }, 100);
                    });
                }
                return function () {
                    return waitUntilImageEditorIsUnlocked(tuiEditor).then(() => cached_function.apply(this, arguments));
                };
            })();

            await tuiEditor.loadImageFromURL(presignedUrl, "SampleImage");

            this.setState({
                imgchang: tuiEditor,
                isImageLoading: false
            });
            tuiEditor.ui.shape.options.strokeWidth = 20;
            tuiEditor.ui.shape.options.stroke = "#ff4040";
            tuiEditor.ui.text._els.textRange._value = 250;
            tuiEditor.ui.text._els.textColorpicker._color = "#ff4040";
            tuiEditor.ui.draw.color = "#ff4040";
            tuiEditor.ui.icon._els.iconColorpicker._color = "#ff4040";
            window.fabric.Object.prototype.controls.mtr.offsetY = -110;
            document.getElementById("#imageDownload").addEventListener("click", async function (e) {
                const { initialValues, imageData, images, initialImages, initialTags, tags, image_changed } = _this.state;
                _this.setState({ isUploading: true });
                _this.isImageEdit = true;
                let currentImageFormat = selectedImages[0].s3_image_key.split(/[#?]/)[0].split(".").pop().trim();
                let currentImageId = selectedImages[0].id;
                let imageUrl = tuiEditor.toDataURL({
                    format: currentImageFormat === "jpg" || currentImageFormat === "jpeg" ? "jpeg" : "png",
                    quality: 1
                });
                const blobImage = await (await fetch(imageUrl)).blob();
                let formData = new FormData();
                formData.append("image_upload_id", selectedImages[0]?.id);
                formData.append("edit_image", blobImage);

                let isFieldUpdate =
                    _.isEqual(initialValues, imageData) && _.isEqual(initialImages, images) && _.isEqual(initialTags, tags) && !image_changed;

                if (!isFieldUpdate) {
                    await _this.handleUpdate();
                }
                await _this.props.saveEditedImage(formData);
                await _this.updateImageData({ is_edited: true });
                _this.setState(
                    {
                        isUploading: false,
                        alertMessage: "Image saved successfully"
                    },
                    async () => {
                        _this.props.onCancel();
                        _this.showAlert();
                        _this.props.updateImagesAfterEdit(currentImageId, true);
                    }
                );
            });

            const deleteButton = document.querySelector(".tie-btn-delete");
            if (deleteButton) {
                deleteButton.remove();
            }
        } catch (error) {
            this.setState({ isImageLoading: false, alertMessage: "Something went wrong: " + error }, () => {
                this.showAlert();
            });
        }
    };

    handleRestoreEditedImage = () => {
        this.setState({
            showRestoreConfirmModal: true
        });
    };

    renderRestoreConfirmationModal = () => {
        const { showRestoreConfirmModal } = this.state;
        if (!showRestoreConfirmModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to restore this image?"}
                        message={""}
                        onNo={() => this.setState({ showRestoreConfirmModal: false })}
                        onYes={this.handleRestoreEditedImageConfirm}
                        type={"restore"}
                        isRestore={true}
                    />
                }
                onCancel={() => this.setState({ showRestoreConfirmModal: false })}
            />
        );
    };

    handleRestoreEditedImageConfirm = async () => {
        const { selectedImages = [] } = this.props;
        let currentImageId = selectedImages[0].id;
        this.setState({
            showRestoreConfirmModal: false
        });
        await this.props.restoreEditedImage({ image_upload_id: selectedImages[0]?.id });
        await this.updateImageData({ is_restored: true });
        this.props.updateImagesAfterEdit(currentImageId, false);
        this.setState(
            {
                alertMessage: "Restored image successfully"
            },
            () => {
                this.props.onCancel();
                this.showAlert();
            }
        );
    };

    render() {
        const {
            isUploading,
            filesCount,
            imageData,
            showErrorBorder,
            errorMessage,
            uploadedFiles,
            showSummaryModal,
            duplicateImages,
            startTime,
            endTime,
            images,
            tags,
            errorParams,
            labelSuggestions,
            user_name,
            currentTab,
            uploadType
        } = this.state;

        const {
            imageReducer: { projectList, buildingList, tradeList, systemList, subsystemList, uploadProgress },
            assetReducer: { dropDownList, dropDownLoading },
            selectedImages,
            imageList
        } = this.props;
        const { entityLabel } = this.getRecommendationEntityLabels();
        let isEdit = selectedImages?.length > 0 ? true : false;
        const hasClient = [UPLOAD_TYPES.ASSET, UPLOAD_TYPES.NORMAL_ASSET, UPLOAD_TYPES.THREE_SIXTY].includes(uploadType);
        const hasProject = [UPLOAD_TYPES.REGULAR, UPLOAD_TYPES.THREE_SIXTY].includes(uploadType);
        const hasRegion = [UPLOAD_TYPES.ASSET, UPLOAD_TYPES.NORMAL_ASSET, UPLOAD_TYPES.THREE_SIXTY].includes(uploadType);
        const hasSite = [UPLOAD_TYPES.ASSET, UPLOAD_TYPES.NORMAL_ASSET, UPLOAD_TYPES.THREE_SIXTY].includes(uploadType);

        const hasBuilding = [UPLOAD_TYPES.REGULAR].includes(uploadType);
        const hasTrade = [UPLOAD_TYPES.REGULAR].includes(uploadType);
        const hasSystem = [UPLOAD_TYPES.REGULAR].includes(uploadType);
        const hasSubsystem = [UPLOAD_TYPES.REGULAR].includes(uploadType);
        const uploadTypeOptions = [
            { id: UPLOAD_TYPES.REGULAR, name: "Regular Images" },
            { id: UPLOAD_TYPES.NORMAL_ASSET, name: "Asset Images" },
            { id: UPLOAD_TYPES.ASSET, name: "Asset Images (ADC File)" },
            ...[localStorage.getItem("role") === "super_admin" ? { id: UPLOAD_TYPES.THREE_SIXTY, name: "360 Degree Images" } : {}]
        ];

        let buildingSelectDropdown = [];
        if (imageData?.site_id) {
            buildingSelectDropdown = dropDownList?.buildings || [];
        } else {
            buildingSelectDropdown = buildingList?.buildings || [];
        }

        return (
            <React.Fragment>
                {this.renderDuplicateModal()}
                {this.renderConfirmationModal()}
                {this.renderInvalidTypeModal()}
                {this.renderCaptionChangeConfirmationModal()}

                {this.renderConfirmationModalLose()}
                {this.renderConfirmationLabelModal()}
                {this.renderNextConfirmationModal()}
                {this.renderPrevConfirmationModal()}
                {this.renderRestoreConfirmationModal()}
                {showSummaryModal ? (
                    <SummaryModal
                        onCancel={this.props.onCancel}
                        images={images}
                        startTime={startTime}
                        endTime={endTime}
                        uploadedFiles={uploadedFiles}
                        duplicateImages={duplicateImages}
                    />
                ) : (
                    <div
                        id="modalId-image"
                        className="modal modal-region modal-img-upload edit-img-wrap"
                        style={{ display: "block", cursor: "move" }}
                    >
                        <ReactTooltip id={selectedImages[0]?.id} effect="solid" place="left" backgroundColor="#1383D9" />

                        <Draggable cancel=".not-draggable">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    {selectedImages?.length === 1 && isEdit && (
                                        <div>
                                            <button
                                                className={`arrow-butn-left ${selectedImages[0]?.id === imageList[0]?.id ? "cursor-diabled" : ""}`}
                                                disabled={selectedImages[0]?.id === imageList[0]?.id}
                                                onClick={() => this.confirmViewPrev()}
                                                data-place="top"
                                                data-effect="solid"
                                                data-tip="Previous"
                                                data-for={selectedImages[0]?.id}
                                            >
                                                <i class="fas fa-chevron-left"></i>
                                            </button>

                                            <button
                                                class={`arrow-butn-right ${
                                                    selectedImages[0]?.id === imageList[imageList.length - 1]?.id ? "cursor-diabled" : ""
                                                }`}
                                                disabled={selectedImages[0]?.id === imageList[imageList.length - 1]?.id}
                                                onClick={() => this.confirmViewNext()}
                                                data-place="top"
                                                data-effect="solid"
                                                data-tip="Next"
                                                data-for={selectedImages[0]?.id}
                                            >
                                                <i class="fas fa-chevron-right"></i>
                                            </button>
                                        </div>
                                    )}
                                    <div className="modal-header">
                                        <h3>
                                            {selectedImages?.length > 1
                                                ? "Edit Images"
                                                : selectedImages?.length
                                                ? "Edit Image"
                                                : this.props.isAssignView
                                                ? this.props.entity === entities.ASSET_MANAGEMENT
                                                    ? "Upload Images to this Asset"
                                                    : this.props.entity === entities.BUILDINGS
                                                    ? "Upload Images to this Building"
                                                    : this.props.entity === entities.SITES
                                                    ? "Upload Images to this Site"
                                                    : this.props.entity === entities.REGIONS
                                                    ? "Upload Images to this Region"
                                                    : `Upload Images to this ${entityLabel}`
                                                : "Upload Images"}
                                        </h3>
                                        <button
                                            type="button"
                                            className="close not-draggable"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                            onClick={this.cancelForm}
                                            disabled={isUploading || this.state.isImageLoading}
                                        >
                                            <span aria-hidden="true">
                                                <img src="/img/close.svg" alt="" />
                                            </span>
                                        </button>
                                    </div>
                                    <div className="modal-body region-otr outer-right-tabpane not-draggable">
                                        {isEdit ? (
                                            <ul className="nav-ul-tab">
                                                <li
                                                    className={currentTab === "details" ? "active cursor-hand" : "cursor-hand"}
                                                    onClick={() => this.handleTabChangeConfirm("details")}
                                                >
                                                    Edit Details
                                                </li>
                                                {selectedImages?.length === 1 && (
                                                    <li
                                                        className={currentTab === "edit image" ? "active cursor-hand" : "cursor-hand"}
                                                        onClick={() => this.handleTabChange("edit image")}
                                                    >
                                                        Edit Image
                                                    </li>
                                                )}
                                            </ul>
                                        ) : null}
                                        {currentTab === "edit image" ? (
                                            <LoadingOverlay active={this.state.isImageLoading} spinner={<Loader />} fadeSpeed={10}>
                                                <div ref={this.imageEditorRef} className="not-draggable tui-image-place-holder"></div>
                                            </LoadingOverlay>
                                        ) : (
                                            <div className="form-area flex-wrap">
                                                <div className="form-sec">
                                                    <div className="form-group">
                                                        <label>User</label>
                                                        <input
                                                            disabled
                                                            type="text"
                                                            value={imageData.user_id ? user_name : ""}
                                                            className="form-control not-draggable"
                                                            placeholder="Username"
                                                        />
                                                    </div>
                                                    <SelectBox
                                                        className="not-draggable"
                                                        label="Upload Type"
                                                        disabled={isEdit || this.props.entity === entities.ASSET_MANAGEMENT}
                                                        value={uploadType}
                                                        handleChange={e => this.setState({ uploadType: e })}
                                                        hasEmptySelect={false}
                                                        optionsList={uploadTypeOptions}
                                                    />
                                                    {(hasClient || (!this.props.entity && UPLOAD_TYPES.REGULAR)) && (
                                                        <SelectBox
                                                            className="not-draggable"
                                                            label="Client *"
                                                            value={imageData.client_id}
                                                            handleChange={e => this.handleClientSelect(e)}
                                                            disabled={this.props.isAssignView}
                                                            optionsList={dropDownList?.clients || []}
                                                            showErrorBorder={showErrorBorder && errorParams.client_id}
                                                        />
                                                    )}
                                                    {hasProject && (
                                                        <SelectBox
                                                            className="not-draggable"
                                                            label="Project *"
                                                            value={imageData.project_id}
                                                            handleChange={e => this.handleProjectSelect(e)}
                                                            disabled={this.props.isAssignView}
                                                            optionsList={projectList?.projects}
                                                            showErrorBorder={showErrorBorder && errorParams.project_id}
                                                        />
                                                    )}
                                                    {(hasRegion || (!this.props.entity && UPLOAD_TYPES.REGULAR)) && (
                                                        <SelectBox
                                                            className="not-draggable"
                                                            label="Region *"
                                                            value={imageData.region_id}
                                                            handleChange={e => this.handleRegionSelect(e)}
                                                            disabled={this.props.isAssignView || dropDownLoading?.regions}
                                                            optionsList={dropDownList?.regions || []}
                                                            showErrorBorder={showErrorBorder && errorParams.region_id}
                                                            isLoading={dropDownLoading?.regions}
                                                        />
                                                    )}
                                                    {(hasSite || (!this.props.entity && UPLOAD_TYPES.REGULAR)) && (
                                                        <SelectBox
                                                            className="not-draggable"
                                                            label="Site *"
                                                            value={imageData.site_id}
                                                            handleChange={e => this.handleSiteSelect(e)}
                                                            disabled={
                                                                (this.props.isAssignView && !(this.props.entity === entities.REGIONS)) ||
                                                                dropDownLoading?.sites
                                                            }
                                                            optionsList={(imageData?.region_id && dropDownList?.sites) || []}
                                                            showErrorBorder={showErrorBorder && errorParams.site_id}
                                                            isLoading={dropDownLoading?.sites}
                                                        />
                                                    )}
                                                    {hasBuilding && (
                                                        <SelectBox
                                                            className="not-draggable build-select-otr"
                                                            label="Building *"
                                                            value={imageData.building_id}
                                                            disabled={
                                                                (this.props.isAssignView &&
                                                                    !(
                                                                        this.props.entity === entities.REGIONS || this.props.entity === entities.SITES
                                                                    )) ||
                                                                buildingList?.loading
                                                            }
                                                            handleChange={e => this.handleBuildingSelect(e)}
                                                            isBuilding
                                                            optionsList={buildingSelectDropdown}
                                                            showErrorBorder={showErrorBorder && errorParams.building_id}
                                                            isLoading={buildingList?.loading}
                                                        />
                                                    )}
                                                    {hasTrade && (
                                                        <SelectBox
                                                            className="not-draggable"
                                                            label={`Trade *`}
                                                            value={imageData.trade_id}
                                                            disabled={tradeList?.loading}
                                                            handleChange={e => this.handleTradeSelect(e)}
                                                            optionsList={imageData?.project_id ? tradeList?.trades : []}
                                                            showErrorBorder={showErrorBorder && errorParams.trade_id}
                                                            isLoading={tradeList?.loading}
                                                        />
                                                    )}
                                                    {hasSystem && (
                                                        <SelectBox
                                                            className="not-draggable"
                                                            label="System"
                                                            disabled={systemList?.loading}
                                                            value={imageData.system_id}
                                                            handleChange={e => this.handleSystemSelect(e)}
                                                            optionsList={imageData?.trade_id ? systemList?.systems : []}
                                                            isLoading={systemList?.loading}
                                                        />
                                                    )}
                                                    {hasSubsystem && (
                                                        <SelectBox
                                                            className="not-draggable"
                                                            label="Sub System"
                                                            disabled={subsystemList?.loading}
                                                            value={imageData.subsystem_id}
                                                            handleChange={e => this.handleSubsytemSelect(e)}
                                                            optionsList={imageData?.system_id ? subsystemList?.sub_systems : []}
                                                            isLoading={subsystemList?.loading}
                                                        />
                                                    )}

                                                    {isEdit ? (
                                                        <div className="form-group col-md-12 p-0">
                                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                <label>Caption</label>
                                                                <span style={{ color: "#7D8185" }}>
                                                                    {imageData.caption?.trim().length ? imageData.caption?.trim().length : 0}/
                                                                    {this.state.captionMaxLength}
                                                                </span>
                                                            </div>
                                                            <input
                                                                type="text"
                                                                maxLength={this.state.captionMaxLength}
                                                                value={imageData.caption}
                                                                onChange={e => {
                                                                    resetCursor(e);
                                                                    this.setState({
                                                                        imageData: { ...imageData, caption: toTitleCase(e.target.value) }
                                                                    });
                                                                }}
                                                                className="form-control not-draggable"
                                                                placeholder="Caption"
                                                            />
                                                            {!imageData.caption && this.props.assetName && (
                                                                <label class="container-check mt-3">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={imageData.caption}
                                                                        onChange={e =>
                                                                            this.setState({
                                                                                imageData: {
                                                                                    ...imageData,
                                                                                    caption: e.target.checked ? this.props.assetName : ""
                                                                                }
                                                                            })
                                                                        }
                                                                        className="form-control not-draggable"
                                                                    />
                                                                    <span class="checkmark"></span> Copy Asset Name
                                                                </label>
                                                            )}
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="upload-area not-draggable position-relative">
                                                    <label>
                                                        {isEdit ? "" : uploadType === UPLOAD_TYPES.THREE_SIXTY ? "Upload Zip File" : "Upload Images"}
                                                    </label>
                                                    <UploadContainer
                                                        isEdit={isEdit}
                                                        handleFileInput={this.handleFileInput}
                                                        filesCount={selectedImages?.length || filesCount}
                                                        isUploading={isUploading}
                                                        uploadedFiles={uploadedFiles}
                                                        selectedImages={selectedImages}
                                                        uploadProgress={uploadProgress}
                                                        setRotate={this.setRotate}
                                                        rotate={this.state.rotate}
                                                        isAssignView={this.props.isAssignView}
                                                        uploadType={uploadType}
                                                    />
                                                </div>
                                                <div className="form-group outer col-md-12 p-0 d-flex flex-wrap label-add-outer">
                                                    <label className="col-12 p-0">Common Labels</label>
                                                    {tags.length > 0 &&
                                                        tags.map((item, index) => (
                                                            <div className="form-group d-flex align-items-center label-del col-md-2 pl-0">
                                                                <div className="col-md-10 pl-0 pr-1">
                                                                    <Autosuggest
                                                                        suggestions={labelSuggestions}
                                                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                                                        getSuggestionValue={this.getSuggestionValue}
                                                                        renderSuggestion={this.renderSuggestion}
                                                                        inputProps={{
                                                                            type: "text",
                                                                            value: tags[index]?.name || "",
                                                                            onChange: (e, { newValue }) => {
                                                                                tags[index].name = newValue;
                                                                                this.setState({ tags });
                                                                            },
                                                                            className: "form-control not-draggable",
                                                                            placeholder: "Label"
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div class="col-md-2 pl-1 pr-0">
                                                                    <button
                                                                        className="del-button not-draggable"
                                                                        onClick={() => {
                                                                            this.labelDelete(index);
                                                                        }}
                                                                    >
                                                                        <i className="fas fa-trash" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    <button
                                                        className="btn add-button-wrapper not-draggable"
                                                        onClick={() => this.setState({ tags: [...tags, { name: "" }] })}
                                                    >
                                                        + Add
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        <div className="btnOtr d-flex flex-wrap p-3">
                                            {!isEdit && this.props.isAssignView && (
                                                <span className="not-draggable note-tag-cls " style={{ backgroundColor: "#ffff0085" }}>
                                                    Please note: Your images will be added to the gallery with the current {entityLabel.toLowerCase()}{" "}
                                                    scope after uploading, but please wait a few minutes for image processing to complete. Then, you
                                                    can select and assign them to the {entityLabel.toLowerCase()}.{" "}
                                                </span>
                                            )}
                                            <span className="errorMessage">{errorMessage}</span>

                                            <button
                                                type="button"
                                                className="btn btn-secondary btnClr not-draggable"
                                                data-dismiss="modal"
                                                onClick={this.cancelForm}
                                                disabled={isUploading || this.state.isImageLoading}
                                            >
                                                Cancel
                                            </button>
                                            {this.props.hasDelete ? (
                                                <button
                                                    type="button"
                                                    class="btn btn-primary btnDlt not-draggable"
                                                    onClick={() => this.props.handleDelete(selectedImages)}
                                                    disabled={isUploading || this.state.isImageLoading}
                                                >
                                                    Delete{" "}
                                                </button>
                                            ) : null}
                                            {currentTab === "edit image" ? (
                                                <>
                                                    {selectedImages[0]?.is_edited && (
                                                        <>
                                                            <ReactTooltip
                                                                id={selectedImages[0]?.id}
                                                                effect="solid"
                                                                place="left"
                                                                backgroundColor="#1383D9"
                                                            />
                                                            <button
                                                                class="btn-save btn-reset mr-3"
                                                                onClick={() => this.handleRestoreEditedImage()}
                                                                disabled={this.state.isImageLoading}
                                                                data-place="top"
                                                                data-effect="solid"
                                                                data-tip="Restore Original Image"
                                                                data-for={selectedImages[0]?.id}
                                                            >
                                                                Restore
                                                            </button>
                                                        </>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className={`btn btn-primary btnRgion not-draggable ${
                                                            selectedImages[0]?.is_edited ? "btn-img-save" : ""
                                                        }`}
                                                        id="#imageDownload"
                                                        disabled={isUploading || this.state.isImageLoading}
                                                    >
                                                        Save{" "}
                                                        {isUploading && <span className="spinner-border spinner-border-sm pl-2" role="status"></span>}
                                                    </button>
                                                </>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btnRgion not-draggable"
                                                    disabled={isUploading}
                                                    onClick={isEdit ? this.handleUpdate : this.handleImageUpload}
                                                >
                                                    {isEdit ? "Update" : "Upload Image"}{" "}
                                                    {isUploading && <span className="spinner-border spinner-border-sm pl-2" role="status"></span>}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const { imageReducer, assetReducer, waterReducer, projectReducer } = state;
    return { imageReducer, assetReducer, waterReducer, projectReducer };
};

const { getBuildingById } = waterActions;

const { getDropdownList } = assetActions;

export default withRouter(connect(mapStateToProps, { ...actions, getDropdownList, getBuildingById })(UploadForm));
